<template lang="html">
  <div class="collect-custom-info">
    <div
      class="section"
      v-for="(section, index) in customInfo"
      :key="'section_' + index"
    >
      <div class="section-title pf-medium">{{ section.title }}</div>
      <template v-if="section.fields">
        <div
          class="section-field-wrapper pf-simbold"
          v-for="(field, i) in section.fields"
          :key="'field_' + i"
        >
          <div class="field">
            <div>{{ field.labelName }}</div>
            <div class="pf-simbold">{{ field.labelValue }}</div>
          </div>
          <div class="devider" v-if="i != section.fields.length - 1"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customInfo: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.collect-custom-info {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);

  .section {
    padding: rem(30px) rem(24px) rem(30px) rem(24px);
    border-radius: rem(16px);
    background: #fff;
    font-size: rem(24px);
    color: #262626;
    line-height: rem(30px);
    margin-bottom: rem(20px);

    .section-title {
      font-size: rem(30px);
      padding: 0 0 rem(30px) 0;
    }

    .section-field-wrapper {
      display: flex;
      flex-direction: column;

      font-size: rem(26px);
      color: #121212;
      font-weight: 500;

      .field {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: rem(22px) 0 rem(22px) 0;
      }
    }
  }

  .devider {
    background: #ededed;
    height: rem(1px);
  }
}
</style>
